import React from 'react';
import PropTypes from 'prop-types';
import Drawer from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Drawer';
import { noop } from 'Helpers/PropTypes';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { DataValueMap } from 'Helpers/Testing';
import { IconButton } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import fr from 'facet-rest';
import { Box, Stack, Paper } from '@facet-wealth/design';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import {
  ThreadToggleStarredButton,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadQuickActions/components/ThreadToggleStarredButton';
import {
  ThreadToggleUnreadButton,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadQuickActions/components/ThreadToggleUnreadButton';
import {
  ThreadToggleArchivedButton,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadQuickActions/components/ThreadToggleArchivedButton';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  ThreadParticipantGroup,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/ThreadParticipantGroup';
import {
  ThreadParticipants,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/ThreadHeader/components/ThreadParticipants';

const useStyles = buildUseStyles('MobileMessageInfoDrawer', (theme) => ({
  drawerPaper: {
    backgroundColor: theme.palette.facet.lightGray,
  },
  participantListLabel: {
    margin: theme.spacing(1),
  },
}));

const MobileMessageInfoDrawer = ({
  open,
  onClose,
  threadResource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const threadParticipants = threadResource?.attr('threadMembers').resources().list() || [];

  return (
    <Drawer
      variant="temporary"
      anchor={'right'}
      open={open}
      classes={{
        paper: classes.drawerPaper,
      }}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
      {...DataValueMap.init('mobile-messages-page-message-info-drawer').build()}
    >
      <Box
        height={'100dvh'}
        width={'100dvw'}
        padding={400} // 16px
      >
        <Stack
          direction={'column'}
          alignItems="flex-start"
          justifyContent="flex-start"
          spacing={2}
        >
          <IconButton
            icon={ChevronLeftIcon}
            onClick={() => onClose()}
            {...DataValueMap.init('mobile-messages-page-message-info-drawer-close').build()}
          />
          <Box
            width={'100%'}
          >
            <Stack justifyContent={'center'} alignItems="flex-start">
              <ThreadParticipantGroup
                threadParticipants={threadParticipants}
                max={4}
                size={'large'}
                spacing={30}
              />
            </Stack>
          </Box>
          <Box
            width={'100%'}
          >
            <Stack justifyContent={'center'} alignItems="flex-start">
              <Typography
                variant={'h4'}
                color={'naturalGreen'}
              >
                {threadResource.attr('subject') || 'No Subject'}
              </Typography>
            </Stack>
          </Box>
          <Box
            width={'100%'}
          >
            <Stack justifyContent={'center'} spacing={2} alignItems="flex-start">
              <Paper height={'100%'}>
                <ThreadToggleStarredButton
                  resource={threadResource}
                  color={'black'}
                  showLabel
                />
              </Paper>
              <Paper height={'100%'}>
                <ThreadToggleUnreadButton
                  resource={threadResource}
                  color={'black'}
                  showLabel
                />
              </Paper>
              <Paper height={'100%'}>
                <ThreadToggleArchivedButton
                  resource={threadResource}
                  color={'black'}
                  showLabel
                />
              </Paper>
            </Stack>
          </Box>
          <Box width={'100%'}>
            <Typography
              className={classes.participantListLabel}
              variant={'h6'}
              color={'textSecondary'}
            >
              {'People in this thread'}
            </Typography>
            <Paper width={'100%'}>
              <ThreadParticipants
                threadParticipants={threadParticipants}
                direction={'column'}
              />
            </Paper>
          </Box>
        </Stack>
      </Box>
    </Drawer>
  );
};

MobileMessageInfoDrawer.defaultProps = {
  open: false,
  onClose: noop,
};

MobileMessageInfoDrawer.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  threadResource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { MobileMessageInfoDrawer };
